import React, { useContext, useEffect, useRef, useState } from "react";
import useDebounce from "../useDebounce";
import "./VehicleDropdownForTrip.css";
import { UserContext } from "context";
import { FaCaretDown, FaCaretUp } from "react-icons/fa6";

const VehicleDropdownForTrip = ({
    label = "Select Item",
    placeholder="",
    fetchData,
    onChange,
    selectedItem = null,
    pageSize = 10,
    disabled = false,
    error = false,
    errorMessage = "",
    isAddButton = false,
    addButtonAction = (e) => { },
    refreshTrigger = null,
}) => {
    const { masterData } = useContext(UserContext);
    
    const [search, setSearch] = useState("");
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [items, setItems] = useState([]);
    const [displayedItems, setDisplayedItems] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [selected, setSelected] = useState(selectedItem);
    const [hasLoadedOnce, setHasLoadedOnce] = useState(false);
    
    const debouncedSearch = useDebounce(search, 500);
    const containerRef = useRef(null);

    useEffect(() => {
        setSelected(selectedItem);
    }, [selectedItem]);

    // Search change par load karo
    useEffect(() => {
        if (dropdownOpen) {
            loadItems(true, debouncedSearch, 1);
        }
    }, [debouncedSearch, refreshTrigger]);

    // 🎯 Dropdown open hone par pehli baar data load karo
    useEffect(() => {
        if (dropdownOpen && !hasLoadedOnce) {
            loadItems(true, search, 1);
            setHasLoadedOnce(true);
        }
        
        // Dropdown close hone par reset
        if (!dropdownOpen) {
            setSearch("");
            setHasLoadedOnce(false);
        }
    }, [dropdownOpen]);

    const loadItems = async (reset = false, query = search, nextPage = 1) => {
        if (!reset) setIsLoadingMore(true);
        
        try {
            const response = await fetchData(query, nextPage, pageSize);
            const newItems = response?.items || [];
            const total = response?.total || 0;

            const merged = reset ? newItems : [...displayedItems, ...newItems];
            setItems(reset ? newItems : [...items, ...newItems]);
            setDisplayedItems(merged);
            setPage(nextPage);
            setHasMore(merged.length < total);
        } catch (error) {
            console.error("Error loading items:", error);
        } finally {
            setIsLoadingMore(false);
        }
    };

    const loadMore = () => {
        if (hasMore && !isLoadingMore) {
            const nextPage = page + 1;
            loadItems(false, search, nextPage);
        }
    };

    const handleScroll = () => {
        const el = containerRef.current?.querySelector(".dropdown-list");
        if (el && el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
            loadMore();
        }
    };

    const handleSelect = (item) => {
        if (disabled) return;
        setDropdownOpen(false);
        onChange && onChange(item);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div ref={containerRef} style={{ position: "relative", width: "100%" }}>
            <div 
                onClick={() => !disabled && setDropdownOpen(!dropdownOpen)}
                style={{
                    border: error ? "1px solid red" : disabled?"1px solid #eeeeeeff":"1px solid #ccc",
                    padding: "10px",
                    borderRadius: 4,
                    cursor: disabled ? "not-allowed" : "pointer",
                    backgroundColor: disabled ? "#fcfcfc" : "#fff",
                }}
            >
                <label
                    style={{
                        position: "absolute",
                        top: dropdownOpen || selected ? -0 : error ? "36%" : "50%",
                        left: 6,
                        fontSize: dropdownOpen || selected ? 12 : 14,
                        color: "#666",
                        background: "#fff",
                        padding: "0 4px",
                        transform: "translateY(-50%)",
                        transition: "all 0.2s ease",
                        pointerEvents: "none",
                    }}
                >
                    {label}
                </label>
                <span style={{
                    color: selected ? "#000" : "#888",
                    fontSize: 14
                }}>
                    {selected?.vehicle_ownership
                        ? `${selected?.vehicle_no} | ${masterData?.vehicle_ownership[selected?.vehicle_ownership]}`
                        : (selected?.name || placeholder || label )}
                </span>
                <span style={{ float: "right" }}>
                    {dropdownOpen ? <FaCaretUp size={13} color="gray" /> : <FaCaretDown size={13} color="gray"/>}
                </span>
            </div>

            {dropdownOpen && !disabled && (
                <div
                    className="dropdown-list"
                    style={{
                        position: "absolute",
                        top: "100%",
                        width: "100%",
                        maxHeight: 250,
                        overflowY: "auto",
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: 4,
                        zIndex: 1000,
                        marginTop: 4,
                        display: "flex",
                        flexDirection: "column",
                    }}
                    onScroll={handleScroll}
                >
                    <div className="__searchIn_multiBx __nwMultiSerch">
                        <input
                            type="text"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Search..."
                            autoFocus
                        />
                    </div>
                    <div className="__otr_checkBx_fl">
                        {displayedItems.map((item) => (
                            <div
                                key={item._id}
                                onClick={() => handleSelect(item)}
                                className={`vehicle-item ${selected?._id === item._id ? "selected" : ""}`}
                            >
                                <div className="anvLrc">
                                    <div className={`_vhlNumber ${selected?._id === item._id ? "selected" : ""}`} style={{fontSize:"15px",alignItems:"center", opacity:1}}>
                                        <p style={{margin:'0px 5px 0px 0px', fontSize:'14px', display:'inline-block', opacity:selected?._id === item._id ? "1" : "0.57"}}>{item.vehicle_no?`${item.vehicle_no} | `:""}</p>
                                         <span
                                         style={{margin:0}}
                                            className={
                                                item.vehicle_ownership == 1
                                                    ? "_trkMark _lrDelivered_status"
                                                    : item.vehicle_ownership == 2
                                                        ? "_trkMark _lrPartyPoint_status"
                                                        : "_trkMark _lrInTransit_status"
                                            }
                                        >
                                            {masterData?.vehicle_ownership[item.vehicle_ownership]}
                                        </span>
                                    </div>
                                    <div className={`_vhlOwnType ${selected?._id === item._id ? "selected" : ""}`}>
                                        {/* <span
                                            className={
                                                item.vehicle_ownership == 1
                                                    ? "_trkMark _lrDelivered_status"
                                                    : item.vehicle_ownership == 2
                                                        ? "_trkMark _lrPartyPoint_status"
                                                        : "_trkMark _lrInTransit_status"
                                            }
                                        >
                                            {masterData?.vehicle_ownership[item.vehicle_ownership]}
                                        </span> */}
                                        {item.lorry_type_id?.lorry_type && item.vehicle_type_id_1?.name
                                            ? ` ${item.lorry_type_id.lorry_type} ${item.vehicle_type_id_1.name}`
                                            : ''}
                                    </div>
                                </div>
                                <div className={`_vhlStatus ${selected?._id === item._id ? "selected" : ""}`}>
                                    <span className="available_status"></span>
                                    {masterData?.vehicle_status[item?.vehicle_status]}
                                </div>
                            </div>
                        ))}
                    </div>

                    {isLoadingMore && (
                        <div style={{ padding: 8, textAlign: "center", fontSize: 12 }}>
                            Loading...
                        </div>
                    )}

                    {!isLoadingMore && displayedItems.length === 0 && (
                        <div style={{ padding: 8, textAlign: "center", fontSize: 12 }}>
                            No Data
                        </div>
                    )}

                    {!hasMore && displayedItems.length > 0 && !isLoadingMore && (
                        <div style={{ padding: 8, textAlign: "center", fontSize: 12, color: "#888" }}>
                            No more items
                        </div>
                    )}

                    {isAddButton && (
                        <div
                            style={{
                                borderTop: "1px solid #ccc",
                                background: "#fff",
                                padding: 5,
                                position: "sticky",
                                bottom: 0,
                                zIndex: 2,
                            }}
                        >
                            <button
                                className="_addNew_cdmBtn"
                                onClick={() => {
                                    addButtonAction();
                                    setDropdownOpen(false);
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                >
                                    <path
                                        d="M8.61539 0C6.33902 0.0276205 4.16368 0.944178 2.55393 2.55393C0.944178 4.16368 0.0276205 6.33902 0 8.61539C0.0276205 10.8917 0.944178 13.0671 2.55393 14.6768C4.16368 16.2866 6.33902 17.2031 8.61539 17.2308C10.8917 17.2031 13.0671 16.2866 14.6768 14.6768C16.2866 13.0671 17.2031 10.8917 17.2308 8.61539C17.2031 6.33902 16.2866 4.16368 14.6768 2.55393C13.0671 0.944178 10.8917 0.0276205 8.61539 0ZM13.5385 9.23077H9.23077V13.5385H8V9.23077H3.69231V8H8V3.69231H9.23077V8H13.5385V9.23077Z"
                                        fill="#1956F6"
                                    />
                                </svg>
                                Add New
                            </button>
                        </div>
                    )}
                </div>
            )}

            {error && errorMessage && (
                <div style={{ color: "var(--invailid-color)", fontSize: 12, marginLeft: 3, marginTop: 3, fontWeight: 500 }}>
                    {errorMessage}
                </div>
            )}
        </div>
    );
};

export default VehicleDropdownForTrip;